import axios from '../../axios'


// 保存
export const save = (data) => {
    return axios({
        url: '/studyTimeSet/save',
        method: 'post',
        data
    })
}
// 删除
export const batchDelete = (data) => {
    return axios({
        url: '/studyTimeSet/delete',
        method: 'post',
        data
    })
}
// 分页查询
export const findPage = (data) => {
    return axios({
        url: '/studyTimeSet/list',
        method: 'post',
        data
    })
}
// 分页查询
export const detailView = (data) => {
    return axios({
        url: '/studyTimeSet/detail',
        method: 'post',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/modules/studytimeset/studytimeset.js